import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { useAuthContext } from "providers/Auth";
import { CsvUploadStatus, CsvUploadStatusResponse } from "./types";
import { useState } from "react";

import { toast } from "react-toastify";

export const useUploadCsvController = () => {
  const { auth, type } = useAuthContext();
  const [csvUploadStatus, setCsvUploadStatus] = useState<
    CsvUploadStatus | "loading"
  >("loading");

  const uploadMeta = useQuery({
    queryKey: ["CSV_UPLOAD_STATUS", auth?.partner.name],
    queryFn: () =>
      instance.get("portal/v1/csv/current").then((res) => {
        if (!res.data) {
          setCsvUploadStatus(CsvUploadStatus.Init);
          return res.data;
        }
        setCsvUploadStatus(res.data.status);

        if (res.data.status === CsvUploadStatus.Executed)
          toast.success("Rent reporting CSV file processed successfully", {
            autoClose: 5000
          });

        if (res.data.status === CsvUploadStatus.Failed)
          toast.error(
            "Failed to upload CSV" +
              (res.data.error_message
                ? `: ${String(res.data.error_message || "")}`
                : ""),
            {
              autoClose: 5000
            }
          );

        if (res.data.status === CsvUploadStatus.Parsed)
          toast.success("Rent reporting CSV file analysis ready to review", {
            autoClose: 5000
          });

        if (
          [CsvUploadStatus.Executed, CsvUploadStatus.Canceled].includes(
            res.data.status
          ) &&
          window.location.pathname === "/rent-reporting"
        )
          window.dispatchEvent(new Event("navigate-to-subscribers"));

        return res.data as CsvUploadStatusResponse;
      }),
    enabled:
      Boolean(auth?.partner) &&
      Boolean(
        Boolean(type.isManual) ||
        Boolean(type.isPMS && type.isBoomOps) ||
        (type.isPMS && type.canManageEntitiesDirectly)
      ) &&
      auth?.partner.status === "active" &&
      (
        [
          CsvUploadStatus.Parsing,
          CsvUploadStatus.Executing,
          "loading"
        ] as string[]
      ).includes(csvUploadStatus),
    retry: false,
    refetchInterval: 4000
  });

  const canUpload =
    !uploadMeta.data ||
    [
      CsvUploadStatus.Executed,
      CsvUploadStatus.Init,
      CsvUploadStatus.Failed,
      CsvUploadStatus.Canceled
    ].includes(uploadMeta.data.status);

  return { uploadMeta, canUpload, csvUploadStatus };
};
